import { ParsedUrlQuery } from 'querystring';
import { VideoEntityBasic } from 'src/models/directus';

export const isVideoTaxonomyInvalid = (
  video: VideoEntityBasic,
  params?: ParsedUrlQuery | undefined,
) => {
  const subject =
    params?.subjectOrSlug === video.slug ? null : params?.subjectOrSlug;
  const bodyPart =
    params?.bodyPartOrSlug === video.slug ? null : params?.bodyPartOrSlug;

  const isSubjectInvalid =
    subject && !video.subjects.find((s) => s.subjects_id.slug === subject);
  const isBodyPartInvalid =
    bodyPart && !video.bodyParts.find((s) => s.bodyParts_id.slug === bodyPart);

  const isInvalid = !!(isSubjectInvalid || isBodyPartInvalid);

  if (isInvalid) {
    console.warn(
      '[getServerSideProps] [medical-education] Invalid video taxonomy',
      video.id,
      subject,
      bodyPart,
    );
  }

  return isInvalid;
};
